"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableFlightCompanyListDefaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../Icon");
exports.tableFlightCompanyListDefaultConfig = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: () => 'Actions',
        id: 'actions',
        Cell: () => {
            return (react_1.default.createElement("span", { className: 'table__action-icons' },
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'edit' })),
                react_1.default.createElement("span", { className: 'table__action-icon' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
        },
    },
];
//# sourceMappingURL=tableFlightCompanyListConfig.js.map